<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm02_title"><a id="page_iii"></a>The Signifying Creator</h1>
<p class="tit"><em>Nontextual Sources of Meaning<br/>in Ancient Judaism</em></p>
<p class="tit1"><strong>Michael D. Swartz</strong></p>
<p class="image"><img alt="image" src="images/f0iii-01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?65ca26be